import { render } from "./PushNotificationInit.vue?vue&type=template&id=1a54fd85"
import script from "./PushNotificationInit.vue?vue&type=script&lang=js"
export * from "./PushNotificationInit.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/PushNotificationInit.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1a54fd85"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1a54fd85', __exports__)) {
    api.reload('1a54fd85', __exports__)
  }
  
  module.hot.accept("./PushNotificationInit.vue?vue&type=template&id=1a54fd85", () => {
    api.rerender('1a54fd85', render)
  })

}


export default __exports__